import { PartFileViewerPageData, PartViewerPageData } from '@frontend/api';

export const getShouldHideFile = (
  part: PartViewerPageData | null,
  partFile: PartFileViewerPageData | null,
): boolean => {
  const isHiddenPrimaryFile = part?.isManual && partFile?.isPrimaryFile;
  return isHiddenPrimaryFile || (partFile?.isDerivedFromInterrogation ?? false);
};
